webpackJsonp([4],{

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'cookie-policy',
	data: function data() {
		return {
			videos: []
		};
	},

	beforeDestroy: function beforeDestroy() {
		if (this.$root && this.$root.closeMenu) {
			this.$root.closeMenu();
		}
	}
});

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(63)(true);
// imports


// module
exports.push([module.i, ".info{background-color:#fff;padding:25px;text-align:left;color:#222;line-height:1.5;-webkit-box-shadow:0 3px 15px rgba(0,0,0,.31);box-shadow:0 3px 15px rgba(0,0,0,.31);margin-bottom:150px}.info h1{font-family:Freckle Face,cursive;font-weight:400!important;margin-top:0;background-color:#666;color:#fff;padding:25px;padding-bottom:10px;margin-left:-25px;margin-top:-25px;margin-right:-25px}.info p{font-family:Open Sans,sans-serif}", "", {"version":3,"sources":["/home/matteo/development/garadirutti/pwa-gdr/src/components/cookie-info.vue"],"names":[],"mappings":"AACA,MACE,sBAAwB,AACxB,aAAc,AACd,gBAAiB,AACjB,WAAY,AACZ,gBAAiB,AACjB,8CAAmD,AAC3C,sCAA2C,AACnD,mBAAqB,CACtB,AACD,SACE,iCAAqC,AACrC,0BAA4B,AAC5B,aAAc,AACd,sBAAuB,AACvB,WAAa,AACb,aAAc,AACd,oBAAqB,AACrB,kBAAmB,AACnB,iBAAkB,AAClB,kBAAoB,CACrB,AACD,QACE,gCAAqC,CACtC","file":"cookie-info.vue","sourcesContent":["\n.info {\n  background-color: white;\n  padding: 25px;\n  text-align: left;\n  color: #222;\n  line-height: 1.5;\n  -webkit-box-shadow: 0 3px 15px rgba(0, 0, 0, 0.31);\n          box-shadow: 0 3px 15px rgba(0, 0, 0, 0.31);\n  margin-bottom: 150px;\n}\n.info h1 {\n  font-family: 'Freckle Face', cursive;\n  font-weight: 400 !important;\n  margin-top: 0;\n  background-color: #666;\n  color: white;\n  padding: 25px;\n  padding-bottom: 10px;\n  margin-left: -25px;\n  margin-top: -25px;\n  margin-right: -25px;\n}\n.info p {\n  font-family: 'Open Sans', sans-serif;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(213);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(64)("4cedaaf2", content, true, {});

/***/ }),

/***/ 241:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infoLayout mainLayout"
  }, [_c('section', {
    staticClass: "info"
  }, [_c('h1', [_vm._v("Cookie Policy")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "info-tech"
    }
  }, [_vm._v("Cookie")]), _vm._v(" "), _c('p', [_vm._v("I cookie piccoli file di testo salvati sul device dell'utente. Solitamente mantengono dati sulle sessioni.")]), _vm._v(" "), _c('h2', [_vm._v("Utilizzo di cookie per il sito web")]), _vm._v(" "), _c('p', [_vm._v("Sul sito attuale i cookie sono usati da Firebase per mantenere i dati di sessione e per permettere a Google il corretto funzionamento dell'applicazione, ad esempio fornirvi l'elenco dei video aggiornati.")]), _vm._v(" "), _c('h2', [_vm._v("Come disattivare i cookie")]), _vm._v(" "), _c('p', [_vm._v("Seguendo le indicazioni qui presenti sara' facile disattivare i cookie, tuttavia cosi' facendo probabilmente non sara' possibile utilizzare questo sito:\n\t\t\t"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.wikihow.it/Disattivare-i-Cookies",
      "target": "_blank"
    }
  }, [_vm._v("https://www.wikihow.it/Disattivare-i-Cookies")])])])])
}]}

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(219)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(241),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/4.6143201f830c7113f063.js